function api() {
    if(process.env.REACT_APP_LOCALHOST){
        return "http://"+window.location.hostname + ":3000/api/"
    }else {
        return "//" + window.location.hostname + ":" + window.location.port + "/api/"
    }
}
function ws() {
    return 'ws://localhost:3001'
}
export default {
    API: api,
    WS: ws
};